






























import Getters from '@/mixins/Getters'
import { EInputMode } from '@/typings'
import { Component, Mixins } from 'vue-property-decorator'

@Component({
  name: 'InputModeButton',
  components: { InputModeButton }
})
export default class InputModeButton extends Mixins(Getters) {
  protected setInputModeManual() {
    this.uiStore.commitInputMode(EInputMode.Manual)
  }

  protected setInputModeImport() {
    this.uiStore.commitInputMode(EInputMode.Import)
  }
}
